// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2TAhw","colMin":"styles_colMin__1M6Pv"};